import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { GoogleComponent } from '@pages/utils/google.component';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { FazerPedidoService } from 'src/app/services/fazer-pedido.service';
import { TagManagerDirective } from '../../directives/tag-manager.directive';

@Component({
    selector: 'alert-confirmar-pedido',
    templateUrl: './alert-confirmar-pedido.component.html',
    styleUrls: ['./alert-confirmar-pedido.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TagManagerDirective]
})
export class AlertConfirmarPedidoComponent extends GoogleComponent implements OnInit, OnChanges {

  @Input() showAlertConfirmaPedido: boolean = false;
  @Input() sourceScreen: string = '';
  @Output() confirmarPedido = new EventEmitter();

  constructor(private readonly fazerPedidoService: FazerPedidoService) {
    super();
  }

  ngOnInit(): void {
    this.fazerPedidoService.messageDataServicePedido.subscribe(
      (event) => { this.showAlertConfirmaPedido = event; }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showAlertConfirmaPedido?.currentValue && this.sourceScreen !== '') {
      const model = this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.screenView, null, null, this.sourceScreen);
      this.tagManagerService.pushTag(model);
    }
  }

  onConfirmarPedido() {
    this.confirmarPedido.emit(true);
    this.showAlertConfirmaPedido = false;
  }

  onFecharConcluirPedido() {
    this.showAlertConfirmaPedido = false;
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.interaction, elementType, elementContent, this.sourceScreen);
  }
}
